import { render, staticRenderFns } from "./FormDynamicFieldMultiselect.vue?vue&type=template&id=15a8bf32&"
import script from "./FormDynamicFieldMultiselect.vue?vue&type=script&lang=ts&"
export * from "./FormDynamicFieldMultiselect.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports